import React, { useEffect } from "react";
import { logoutRSO } from "@shared/api/rso";
import { RiotLoginButton } from "@shared/Toolbar/AuthButton/RiotLoginButton";
import RiotIcon from "@assets/icons/riot.svg?react";
import LogoutIcon from "@assets/icons/logout.svg?react";
import { clearRSOState, updateRSOToken, useRSOToken } from "@shared/states/rsoState";

export interface RsoMenuProps {}

const RiotAccountMenu: React.FC<RsoMenuProps> = (props) => {
	const rso = useRSOToken();

	useEffect(() => {
		updateRSOToken();
	}, []);

	const handleLogout = async () => {
		await logoutRSO();
		clearRSOState();
	};

	if (!rso.account || rso.loading) {
		return (
			<div className={"mb-2"}>
				<RiotLoginButton />
			</div>
		);
	}

	return (
		<div className={"text-white mb-2"}>
			<div className={"flex font-bold"}>Riot Account:</div>
			<div className={"flex gap-2 items-center"}>
				<div className={"flex gap-1 items-center"}>
					<RiotIcon width={14} />
					<span>
						{rso.account.gameName}#{rso.account.tagLine}
					</span>
				</div>
				<div
					onClick={handleLogout}
					className={
						"text-red-500 cursor-pointer hover:brightness-105 opacity-70 hover:opacity-100"
					}
				>
					<LogoutIcon height={20} />
				</div>
			</div>
		</div>
	);
};

export { RiotAccountMenu };
